import { Directive, ElementRef, HostListener, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[appOnlyNumbers]',
  standalone: true,
})
export class OnlyNumbersDirective {
  constructor(
    private el: ElementRef<HTMLInputElement>,
    @Optional() @Self() private ngControl: NgControl
  ) {}

  @HostListener('input', ['$event'])
  onInput(e: Event) {
    const initialValue = this.el.nativeElement.value || '';
    const sanitized = initialValue.replace(/\D+/g, ''); // quita todo lo que no sea número

    if (sanitized !== initialValue) {
      // actualiza el valor visible
      this.el.nativeElement.value = sanitized;

      // actualiza el FormControl para que form.value también quede limpio
      if (this.ngControl?.control) {
        this.ngControl.control.setValue(sanitized, { emitEvent: false });
      }
    }
  }
}
